export default "__VITE_ASSET__fAOgob_I__"